import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

const EmperorVillaEstate = () => {
  const heroImages = [
    "/assets/img/estates/Emperor Villa Estate.png",
    "/assets/img/estates/Emperor Villa Estate_2.png",
  ];

  const pricing = [
    { type: "3‑Bedroom Apartment", price: "₦45M" },
    { type: "Terrace", price: "₦120M" },
    { type: "5‑Bedroom Duplex", price: "₦140M" },
  ];

  const highlights = [
    { icon: "fa-home", text: "Exquisitely finished homes – ready to move in" },
    { icon: "fa-building", text: "Contemporary architectural design" },
    { icon: "fa-shower", text: "All rooms en‑suite with top‑quality sanitary fittings" },
    { icon: "fa-utensils", text: "Fully fitted kitchens with modern cabinetry" },
    { icon: "fa-couch", text: "Expansive living and dining areas" },
    { icon: "fa-paint-brush", text: "Premium interior finishes" },
  ];

  const amenities = [
    { icon: "fa-shield-alt", text: "24/7 top‑tier security with CCTV" },
    { icon: "fa-fence", text: "Secure perimeter fencing" },
    { icon: "fa-road", text: "Smooth paved internal roads with drainage" },
    { icon: "fa-water", text: "Reliable water supply & standby power" },
    { icon: "fa-leaf", text: "Beautifully landscaped green areas" },
    { icon: "fa-trash-can", text: "Structured waste management system" },
  ];

  return (
    <>
      <style>{`
        .estate-page {
          animation: fadeIn 0.6s ease;
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }

        /* ========= Hero Section – Flex Layout ========= */
        .hero-section {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 4rem 2rem;
          background: linear-gradient(135deg, #f9f9f9 0%, #ffffff 100%);
          border-radius: 0 0 30px 30px;
          gap: 3rem;
          flex-wrap: wrap;
          position: relative;
          overflow: hidden;
        }
        .hero-section::before {
          content: '';
          position: absolute;
          top: -50px;
          right: -50px;
          width: 200px;
          height: 200px;
          background: #e86b24;
          opacity: 0.05;
          border-radius: 50%;
          z-index: 0;
        }
        .hero-text {
          flex: 1 1 400px;
          max-width: 550px;
          position: relative;
          z-index: 1;
        }
        .hero-text h1 {
          font-size: 2.5rem;
          font-weight: 700;
          color: #0a1a3d;
          line-height: 1.2;
          margin-bottom: 1.5rem;
        }
        .hero-text h1 span {
          color: #e86b24;
          position: relative;
        }
        .hero-text h1 span::after {
          content: '';
          position: absolute;
          bottom: -4px;
          left: 0;
          width: 60px;
          height: 3px;
          background: #e86b24;
          border-radius: 2px;
        }
        .hero-text p {
          font-size: 1.1rem;
          color: #555;
          line-height: 1.7;
        }
        .hero-image {
          flex: 1 1 400px;
          max-width: 500px;
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 20px 50px rgba(0,0,0,0.1);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .hero-image:hover {
          transform: translateY(-5px);
          box-shadow: 0 25px 60px rgba(0,0,0,0.15);
        }
        .hero-image img {
          width: 100%;
          height: auto;
          display: block;
          object-fit: cover;
        }

        .content-section {
          max-width: 1000px;
          margin: 2rem auto;
          padding: 0 20px;
        }
        .card {
          background: #fff;
          border-radius: 16px;
          padding: 30px;
          box-shadow: 0 8px 24px rgba(0,0,0,0.04);
          margin-bottom: 2rem;
        }
        .card h2 {
          font-size: 1.8rem;
          font-weight: 700;
          color: #0a1a3d;
          margin-bottom: 1rem;
          display: inline-block;
        }
        .underline-orange {
          position: relative;
          display: inline-block;
        }
        .underline-orange::after {
          content: '';
          position: absolute;
          bottom: -4px;
          left: 0;
          width: 0;
          height: 3px;
          background: #e86b24;
          transition: width 0.3s ease;
        }
        .underline-orange:hover::after {
          width: 100%;
        }

        .price-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 20px;
          margin: 1.5rem 0;
        }
        .price-item {
          background: #f9f9f9;
          border: 2px solid transparent;
          border-radius: 14px;
          padding: 25px 15px;
          text-align: center;
          transition: transform 0.3s, box-shadow 0.3s, border-color 0.3s;
          cursor: default;
        }
        .price-item:hover {
          transform: translateY(-5px);
          box-shadow: 0 12px 30px rgba(0,0,0,0.1);
          border-color: #e86b24;
        }
        .price-item h3 {
          color: #e86b24;
          font-weight: 700;
          font-size: 1.6rem;
          margin-bottom: 0.5rem;
        }
        .price-item p {
          color: #555;
          font-size: 0.95rem;
        }

        .icon-card-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 20px;
        }
        .icon-card {
          background: #f9f9f9;
          border: 2px solid transparent;
          border-radius: 14px;
          padding: 25px 20px;
          display: flex;
          align-items: flex-start;
          gap: 15px;
          transition: transform 0.3s, box-shadow 0.3s, border-color 0.3s;
          height: 100%;
          box-sizing: border-box;
        }
        .icon-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 10px 25px rgba(0,0,0,0.08);
          border-color: #e86b24;
        }
        .icon-card i {
          font-size: 1.8rem;
          color: #e86b24;
          flex-shrink: 0;
          width: 40px;
          text-align: center;
        }
        .icon-card span {
          font-size: 0.95rem;
          color: #333;
          line-height: 1.5;
        }

        .creative-card {
          background: #fff;
          border-radius: 16px;
          padding: 30px;
          box-shadow: 0 8px 24px rgba(0,0,0,0.04);
          margin-bottom: 2rem;
          display: flex;
          align-items: center;
          gap: 20px;
          border-left: 5px solid #e86b24;
          transition: transform 0.3s, box-shadow 0.3s;
        }
        .creative-card:hover {
          transform: translateY(-3px);
          box-shadow: 0 12px 30px rgba(0,0,0,0.08);
        }
        .creative-card .icon {
          font-size: 2.5rem;
          color: #e86b24;
          flex-shrink: 0;
        }
        .creative-card .details h3 {
          font-size: 1.5rem;
          font-weight: 600;
          color: #0a1a3d;
          margin-bottom: 0.5rem;
        }
        .creative-card .details p {
          color: #555;
          font-size: 0.95rem;
          line-height: 1.6;
        }

        .register-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          background: #25D366;
          color: #fff;
          padding: 15px 35px;
          border-radius: 50px;
          font-weight: 700;
          font-size: 1.1rem;
          text-decoration: none;
          transition: background 0.3s, transform 0.3s, box-shadow 0.3s;
          box-shadow: 0 8px 20px rgba(37, 211, 102, 0.3);
        }
        .register-btn:hover {
          background: #1da851;
          transform: translateY(-2px);
          box-shadow: 0 12px 28px rgba(37, 211, 102, 0.4);
        }

        @media (max-width: 768px) {
          .hero-section {
            flex-direction: column-reverse;
            padding: 2rem 1rem;
            gap: 2rem;
          }
          .hero-text h1 {
            font-size: 2rem;
          }
          .creative-card {
            flex-direction: column;
            text-align: center;
          }
        }
      `}</style>

      <div className="estate-page">
        {/* Hero Section – Flex Layout */}
        <div className="hero-section">
          <div className="hero-text">
            <h1>
              <span>Emperor Villa Estate</span><br />Kodo, FCT Abuja (behind Life Camp)
            </h1>
            <p>
              Welcome to Emperor Villa Estate, an exclusive residential development
              nestled in the tranquil, highly sought‑after district of Kodo,
              strategically positioned just behind Life Camp.
            </p>
          </div>
          <div className="hero-image">
  <img src="/assets/img/estates/Emperor Villa Estate_2.png" alt="Emperor Villa Estate" />
</div>
        </div>

        <div className="content-section">
          <div className="creative-card">
            <div className="icon"><i className="fal fa-city"></i></div>
            <div className="details">
              <h3>Redefining Urban Living in Abuja</h3>
              <p>
                Welcome to Emperor Villa Estate, an exclusive residential
                development nestled in the tranquil, highly sought‑after district of
                Kodo, strategically positioned just behind Life Camp, Abuja. Designed
                to offer a seamless blend of modern luxury, functionality, and
                timeless elegance, the estate features exquisitely finished
                2‑bedroom apartments, stylish terraces, and grand 5‑bedroom
                duplexes.
              </p>
              <p>
                At Emperor Villa Estate, every detail is thoughtfully crafted from
                the contemporary exterior architecture to the premium interior
                finishes ensuring residents enjoy both ultimate comfort and class.
              </p>
            </div>
          </div>

          <div className="card">
            <h2 style={{ display: 'block', textAlign: 'center', width: '100%' }}>
              Available Properties & Pricing
            </h2>
            <div className="price-grid">
              {pricing.map((item, idx) => (
                <div className="price-item" key={idx}>
                  <h3>{item.price}</h3>
                  <p>{item.type}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="card">
            <h2><span className="underline-orange">Property Highlights</span></h2>
            <div className="icon-card-grid">
              {highlights.map((item, idx) => (
                <div className="icon-card" key={idx}>
                  <i className={`fal ${item.icon}`}></i>
                  <span>{item.text}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="card">
            <h2><span className="underline-orange">Estate Features & Amenities</span></h2>
            <div className="icon-card-grid">
              {amenities.map((item, idx) => (
                <div className="icon-card" key={idx}>
                  <i className={`fal ${item.icon}`}></i>
                  <span>{item.text}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="creative-card">
            <div className="icon"><i className="fal fa-map-marker-alt"></i></div>
            <div className="details">
              <h3>Prime Location in Kodo</h3>
              <p>
                Exclusive neighborhood just behind Life Camp with seamless access
                to Gwarinpa, the Central Business District, and the Kubwa
                Expressway. Close to top‑tier schools, shopping centers, and
                leisure destinations.
              </p>
            </div>
          </div>

          <div className="text-center" style={{ marginTop: '2rem' }}>
            <a
              href="https://wa.me/23407055558942?text=Hello%2C%20I%20am%20interested%20in%20Emperor%20Villa%20Estate%20(Kodo)"
              target="_blank"
              rel="noopener noreferrer"
              className="register-btn"
            >
              <i className="fab fa-whatsapp me-2"></i> Register Interest via WhatsApp
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmperorVillaEstate;